// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rxPJ","content":"styles_content__149ju"};